import * as React from 'react';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';

export default {
  BACKFILL_MODAL: {
    title: (pendingTeacherRequestCount: number, pendingClassRequestCount: number) =>
      `This will affect existing
      ${pendingTeacherRequestCount ? 'teachers' : ''}
      ${pendingTeacherRequestCount && pendingClassRequestCount ? 'and' : ''}
      ${pendingClassRequestCount ? 'classes' : ''}`,
    subtext: {
      teachers: (pendingTeacherRequestCount: number) =>
        pendingTeacherRequestCount > 0
          ? `${pendingTeacherRequestCount} unverified teacher${
              pendingTeacherRequestCount > 1 ? 's' : ''
            }
            will be asked to request administrator approval or change their role to student or parent.`
          : '',
      classes: (pendingClassRequestCount: number) =>
        pendingClassRequestCount > 0
          ? `${pendingClassRequestCount} class${pendingClassRequestCount > 1 ? 'es' : ''} 
            owned by students, parents and unverified teachers will be pending and class owners will be asked to request administrator approval or archive the class.`
          : '',
    },
    buttons: {
      submit: {
        copy: 'Apply changes',
      },
      learnMore: {
        copy: 'Learn more',
        href: 'https://remind101.zendesk.com/knowledge/articles/360012343319/en-us?brand_id=108636',
      },
    },
  },

  CLASS_CREATION_TO_HELPTEXT_SCHOOL: {
    open: 'Anyone can create classes at this school.',
    requireApproval:
      'Classes created by students and parents need to be approved by an administrator. Teacher- or SIS-created classes are approved automatically.',
  },

  CLASS_CREATION_TO_HELPTEXT_DISTRICT: {
    open: 'Anyone can create classes at this district.',
    requireApproval:
      'Classes created by students and parents need to be approved by an administrator. Teacher- or SIS-created classes are approved automatically.',
  },

  CLASS_CREATION_TO_LABEL: {
    open: 'Open',
    requireApproval: 'Require approval',
  },

  CLASS_CREATION_TOOLTIP: 'To enable this option, select “Require approval” for teacher signup.',

  CONFIRM_DIALOG: {
    title: 'You haven’t saved your changes',
    body:
      'Click save at the bottom of the screen and decide if you want to apply the changes to existing classes at your school.',
    buttons: {
      action: 'Discard changes',
      cancel: 'Go back',
    },
  },

  APPROVAL_HEADER_TITLE: 'Approvals',

  APPROVAL_HEADER_SUBTEXT: {
    text:
      'Requests for approval will appear in the people and class list of each school.',
    learnMoreLink: {
      copy: 'Learn more',
      href: 'https://remind101.zendesk.com/knowledge/articles/360012343319/en-us?brand_id=108636',
    },
    additionalText: 'Go to settings at the school-level to change the settings from the district default.',
  },

  CLASSCODE_HEADER_TITLE: {
    School: 'School code',
    District: 'District code',
  },

  CLASSCODE_HEADER_SUBTEXT: {
    School:
      'This code allows people to join the school directly and receive schoolwide announcements.',
    District:
      'This code is for internal district use only. Use it when submitting a list of people who need district administrator access. Please contact support via rmd.me/help with questions.',
  },

  HEADER_TITLE: 'Organization settings',

  HEADING_FOR_SETTING_TYPE: {
    teacherSignup: 'Teacher signup',
    classCreation: 'Class creation',
  },

  PENDING_REQUESTS_MODAL: {
    title: 'Approve pending requests?',
    subtext: 'If you set teacher signup and class creation to open, all pending teacher and class requests will be approved.',
    buttons: {
      submit: {
        copy: 'Approve requests',
      },
      cancel: {
        copy: 'Cancel',
      },
    },
  },

  TEACHER_SIGNUP_TO_LABEL: {
    open: 'Open',
    requireApproval: 'Require approval',
  },

  TEACHER_SIGNUP_TO_HELPTEXT_DISTRICT: {
    open: 'Anyone can sign up as a teacher at this district.',
    requireApproval:
      'People who join the district as a teacher need to be approved by an administrator. SIS-synced teachers are approved automatically.',
  },

  TEACHER_SIGNUP_TO_HELPTEXT_SCHOOL: {
    open: 'Anyone can sign up as a teacher at this school.',
    requireApproval:
      'People who join the school as a teacher need to be approved by an administrator. SIS-synced teachers are approved automatically.',
  },

  SCHOOL_URGENT_MESSAGING_TITLE: 'Urgent messaging',

  SCHOOL_URGENT_MESSAGING_LABEL: 'Allow school administrators to send urgent messages',

  SCHOOL_URGENT_MESSAGING_HELPTEXT: 'If unchecked, only district administrators can send urgent messages.',

  CONFIRM_TEACHER_SIGNUP_REQUIRE_APPROVAL_MODAL: {
    title: 'Turning teacher approval on',
    subtext: (
      <p><br/>
      Next steps after turning teacher approval on:<br/><br/>
      1. <b>Review existing teachers</b> in the people list to make sure they have the correct role.<br/><br/>
      2. <b>Approve pending requests</b> to be a teacher. Administrators will be notified by email of pending requests.<br/><br/>
      <Link href={LinkConstants.ZENDESK} target="_blank">Learn more with a step-by-step guide</Link><br/>
    </p>
    ),
    buttons: {
      submit: {
        copy: 'Apply changes',
      },
      cancel: {
        copy: 'Cancel',
      },
    },
  },

  CONFIRM_ALL_REQUIRE_APPROVAL_MODAL: {
    title: 'Turning approvals on',
    subtext: (
        <p><br/>
        Next steps after turning on teacher and class approvals:<br/><br/>
        1. <b>Review existing teachers</b> in the people list to make sure they have the correct role.<br/><br/>
        2. <b>Review existing classes</b> in the class list to make sure there are no unwanted classes.<br/><br/>
        3. <b>Approve pending requests</b> to be a teacher or make a class. Administrators will be notified by email of pending requests.<br/><br/>
        <Link href={LinkConstants.ZENDESK} target="_blank">Learn more with a step-by-step guide</Link><br/>
      </p>
    ),
    buttons: {
      submit: {
        copy: 'Apply changes',
      },
      cancel: {
        copy: 'Cancel',
      },
    },
  },
};
